import { css } from '@emotion/react';
import styled from '@emotion/styled';

import StringInput from '../StringInput';

export const Container = styled.div`
	display: flex;
	min-height: 4.5rem;

	body[dir='rtl'] & {
		min-height: 5.5rem;
	}
`;

export const InputWrapper = styled.div`
	display: flex;
	position: relative;
	width: 100%;
`;

export const Wrapper = styled.ul`
	display: flex;
	flex-wrap: wrap;
	overflow: auto;
	list-style: none;
	cursor: text;
	clear: left;
	margin: 0;
	padding: 0 1.5rem 0 0;
	background-color: var(--white);
	max-height: 10rem;
	border: 1px solid var(--border-color);
	border-radius: var(--small-border-radius);
	width: 100%;

	:hover {
		background-color: var(--table-selected-color);

		input {
			background-color: var(--table-selected-color);
		}
	}
	:focus-within {
		background-color: var(--table-selected-color);
		border: 1px solid var(--blue);
	}

	body[dir='rtl'] & {
		padding: 0 0 0 1.5rem;
		max-height: 11rem;
	}
`;

export const Token = styled.li`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	flex: 0 0 auto;
	margin: 0.38rem 0.25rem;
	padding: 0.25rem var(--padding-1) 0.25rem var(--padding-3);
	height: 3.5rem;
	border-radius: 400px;
	border: 1px solid var(--blue-70);
	background-color: var(--blue-10);
	color: var(--black);
	cursor: default;
	overflow: hidden;
	max-width: 12rem;

	> .icon {
		cursor: pointer;
	}

	> svg {
		padding: var(--padding-1);
		margin-left: var(--margin-1);
		border-radius: 50%;
		width: 1.2rem;
		height: 1.2rem;
		cursor: pointer;

		:hover {
			background-color: var(--actionButtonHoverColor);
		}
	}

	body[dir='rtl'] & {
		padding: 0.25rem var(--padding-3) 0.25rem var(--padding-1);
	}
`;

export const InputToken = styled.li`
	display: inline-flex;
	align-items: center;
	flex: 1 1 auto;
	margin: 0;
	color: var(--black);
	cursor: text;
	overflow: hidden;
`;

export const Input = styled(StringInput)`
	border: 0 none !important;
	outline: 0 none !important;
	padding: 0.5rem 1.5rem 0.5rem 0.5rem !important;
`;

export const AddButtonCss = (props) => css`
	&.borderless {
		position: absolute;
		right: 1rem;
		top: 0;
		height: 100%;
		margin: auto;
		padding: 0;
		pointer-events: ${props.disabled ? 'none' : 'auto'};
		color: ${props.disabled ? 'var(--content-4) !important;' : 'inherit'};

		body[dir='rtl'] & {
			right: unset;
			left: 1rem;
		}
	}
	&.borderless&:hover,
	&.borderless&:focus {
		background: transparent;
		cursor: pointer;
	}
`;
